import { PropsWithChildren } from 'react';

export const AppLayout = (props: PropsWithChildren) => {
  return <>{props.children}</>;
};
